import React from 'react';

import Opt from '../../hooks/opt.js';

function Option({ scope, loadWholeScope = false, locale = I18n.locale, children }) {
  const translationKey = children;

  const optScopeQuery = Opt.useOptScope({
    scope,
    locale,
    enabled: loadWholeScope && !!translationKey,
  });

  const optQuery = Opt.useOpt({
    scope,
    key: translationKey,
    locale,
    enabled: !loadWholeScope && !!translationKey,
  });

  if (!translationKey) return <></>;

  const value = loadWholeScope ? optScopeQuery.getLabel(translationKey) : optQuery.value;

  return <>{value}</>;
}

export default Option;
